import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { IndSectionHeaderViewDataModel } from "@omni/models/indSectionHeaderDataModel";
import { takeUntil } from "rxjs/operators";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";
import { Subject } from "rxjs";
import { IndFormFieldViewDataModel } from "@omni/models/indFormFieldDataModel";
import { isEmpty } from 'lodash-es';
import { observeScaleToFit } from '@omni/utility/scale-to-fit.utility';


@Component({
  selector: 'ind-slide-modal',
  templateUrl: 'ind-slide-modal.html',
  styleUrls:['ind-slide-modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class IndSlideModalComponent {
  @Input() viewData: any;
  @ViewChild('previewScaleContainer') previewScaleContainer: ElementRef<HTMLElement>;
  @ViewChild('previewScaleTarget') previewScaleTarget: ElementRef<HTMLElement>;
  private _disposePreviewScaleToFit: () => void;

  ngDestroy$: Subject<boolean> = new Subject<boolean>();
  public slideModalReplacementHeader: IndSectionHeaderViewDataModel;
  public slideModalPreviewHeader: IndSectionHeaderViewDataModel;
  public slides: any[] = [];
  public selectedSlideHtml: SafeHtml;
  public selectedSlide: any;
  public isGeneralSectionEnabled: boolean = false;
  public isTemplatePreview: boolean = false;

  constructor(
    public translate: TranslateService,
    private screenOrientation: ScreenOrientation,
    private readonly modalCtrl: ModalController,
    private readonly sanitizer: DomSanitizer,
    private _cd: ChangeDetectorRef,
  ) {
    this.screenOrientation
    .onChange()
    .pipe(takeUntil(this.ngDestroy$))
    .subscribe(() => {
      this.modalCtrl.dismiss();
      this._cd.markForCheck();
    });
  }
  
  ngOnInit() {
    if(!isEmpty(this.viewData) && !isEmpty(this.viewData.data)) {
      this.slides = this.viewData.data.replacementTokens;
      this.selectedSlide = this.slides.find(s => s.is_default);
      this.selectedSlideHtml = this.sanitizer.bypassSecurityTrustHtml(this.slides.find(s => s.is_default).replacement_value);
    } else if(!isEmpty(this.viewData) && !isEmpty(this.viewData.htmlString)) {
      this.isTemplatePreview = true;
      this.selectedSlideHtml = this.viewData.htmlString;
    }
    this._initSectionHeader();
  }

  ngAfterViewInit() {
    const container = this.previewScaleContainer?.nativeElement;
    const target = this.previewScaleTarget?.nativeElement;
    if (container && target) {
      this._disposePreviewScaleToFit = observeScaleToFit(target, container);
    }
  }

  ngOnDestroy() {
    this.isTemplatePreview = false;
    this.ngDestroy$.next(true);
    this.ngDestroy$.unsubscribe();
    this._disposePreviewScaleToFit?.();
  }

  private _initSectionHeader() {
    this.slideModalReplacementHeader = {
      id: 'slide-modal-replacement-header',
      title: this.translate.instant('CONTENTS'),
      controls: []
    }
    let buttons = [];
    buttons.push({
      id: 'slide-go-backward',
      isDisabled: false,
      iconName:'chevron-back-outline'
    },{
      id: 'slide-go-forward',
      isDisabled: false,
      iconName: 'chevron-forward-outline'
    },{
      id: 'slide-close',
      isDisabled: false,
      icon: 'assets/imgs/preview_close.svg'
    },{
      id: 'slide-select',
      isDisabled: false,
      icon: 'assets/imgs/preview_select.svg'
    })
    this.slideModalPreviewHeader = {
      id: 'slide-modal-preview-header',
      title: this.isTemplatePreview ? this.translate.instant('PREVIEW') : this.translate.instant('EDIT'),
      controls: this.isTemplatePreview ? [] : buttons
    }
  }

  public onSectionHeaderControlClick(id: string) {
    switch(id) {
      case 'slide-go-backward':
        this.goBackward();
        break;
      case 'slide-go-forward':
        this.goForward();
        break;
      case 'slide-close':
        this.modalCtrl.dismiss( );
        break;
      case 'slide-select':
        const data = { selectedItem: this.selectedSlide.replacement_id, isDone: true }
        this.modalCtrl.dismiss(data);
        break;
      default:
        console.log("Unhandled switch case statement");
        break;
    }
  }

  public getSlideNameFormField(): IndFormFieldViewDataModel {
    let viewData: IndFormFieldViewDataModel;
    viewData = {
      label: this.translate.instant('NAME'),
      inputText: this.viewData.data.indskr_name,
      id: 'name-field',
      isReadOnly: true,
      isDisabled: true,
      showArrow: false,
    };
    return viewData;
  }

  public goForward() {
    let numOfSlides = this.slides.length;
    let currentIdx = this.slides.findIndex(sl => sl.replacement_id == this.selectedSlide.replacement_id);
    let nextIdx = currentIdx+1 < numOfSlides ? currentIdx+1 : 0;
    this.slides[currentIdx].is_default = false;
    this.slides[nextIdx].is_default = true;
    this.selectedSlide = this.slides[nextIdx];
    this.selectedSlideHtml = this.sanitizer.bypassSecurityTrustHtml(this.selectedSlide.replacement_value);
    console.log("go forward to the next slide");
  }

  public goBackward() {
    let numOfSlides = this.slides.length;
    let currentIdx = this.slides.findIndex(sl => sl.replacement_id == this.selectedSlide.replacement_id);
    let prevIdx = currentIdx-1 < 0 ? numOfSlides-1 : currentIdx-1;
    this.slides[currentIdx].is_default = false;
    this.slides[prevIdx].is_default = true;
    this.selectedSlide = this.slides[prevIdx];
    this.selectedSlideHtml = this.sanitizer.bypassSecurityTrustHtml(this.selectedSlide.replacement_value);
    console.log("go backward to the previous slide");
  }

  public selectSlide(event, slide) {
    console.log("show this selected slide");

  }


  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
}